import { render, staticRenderFns } from "./material_temas.vue?vue&type=template&id=67876f4e"
import script from "./material_temas.vue?vue&type=script&lang=js"
export * from "./material_temas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports